import React from 'react';
import { Modal } from 'antd';
import { sanitizeHtml } from '../../utils/sanitizeHtml';

const KvkkContentModal = ({ open, onClose, content, version, type, label }) => {
  const typeLabel = label || (type === 'parent' ? 'Veli' : 'Çalışan');

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={`KVKK Aydınlatma Metni — ${typeLabel} (v${version})`}
      width={800}
      styles={{ body: { maxHeight: '70vh', overflowY: 'auto', padding: '24px' } }}
    >
      <div
        className="kvkk-content"
        style={{ fontFamily: 'inherit', lineHeight: 1.7, color: '#333' }}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}
      />
    </Modal>
  );
};

export default KvkkContentModal;
